"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCORDION_PANEL_CATEGORY_KEY = 'base';
exports.ACCORDION_PANEL_COMPONENT_KEY = 'accordionPanel';